'use strict';

let Cookies = require('js-cookie/src/js.cookie.js');
let form = require('../components/ajaxForm');

$(document).ready(function () {

    //==============
    //====MODALS====
    //=============
    var $article = $(".page").find(".article");

    if ($article.length == 0) {
        return;
    }

    //======================
    //====DALSI CLANKY======
    //======================
    var $otherArticlesContainer = $('#other-articles');

    $otherArticlesContainer.one('inview', function (event, visible) {
        if (visible == true) {
            dataLayer.push({
                'event': 'ga.event',
                'eCategory': 'Článek',
                'eAction': 'Zobrazení',
                'eLabel': 'Další-články',
                'eNonInteraction': true
            });
        }
    });

    $otherArticlesContainer.find('.link-article').on('click', function (e) {
        e.preventDefault();

        var $link = $(this);

        dataLayer.push({
            'event': 'ga.event',
            'eCategory': 'Článek',
            'eAction': 'Klik',
            'eLabel': 'Další-články',
            'eventCallback': function () {
                window.location.href = $link.attr('href');
            }
        });
    });

    //===================
    //====FOOTER FORM====
    //===================

    var $footerForm = $('.footer').find('form');
    var $footerFormMsg = $footerForm.find('.form-message');
    var $footerSubmitBtn = $footerForm.find('button[type=submit]');

    $footerSubmitBtn.on('click', function (e) {
        e.preventDefault();
        form.ajaxSubmitForm($footerForm, $footerFormMsg);
    });

    //====================
    //====POPUP CLANKY====
    //====================
    var $popup = parseInt($article.data("popup"), 10);
    var $popupTime = $article.data("popup-time");
    var $modal = '';
    var type = '';
    var isNewsletterPopup = $popup === 1;
    var showNewsletterPopup = Cookies.get('not_show_newsletter_modal') === 'undefined';

    if (!isNewsletterPopup) {
        $modal = $('#modalEbook');
        type = 'Ebook';
    }
    else {
        $modal = $('#modalNewsletter');
        type = 'Newsletter';
    }

    var popupId = $popup;

    if (popupId != 0) {

        var cookieModal = Cookies.get('elektrina_cz_modal');

        if (cookieModal != popupId || (isNewsletterPopup && showNewsletterPopup)) {
            setTimeout(function () {
                $modal.modal('show');

                Cookies.set('elektrina_cz_modal', popupId, 30);
                dataLayer.push({
                    'event': 'ga.event',
                    'eCategory': 'Pop-up',
                    'eAction': 'Zobrazení',
                    'eLabel': type,
                    'eNonInteraction': true
                });

            }, $popupTime * 1000);
        }

        var $form = $modal.find('form');
        var $formMsg = $form.find('.form-message');
        var $submitBtn = $form.find('button[type=submit]');

        $submitBtn.on('click', function (e) {
            e.preventDefault();
            var gtmData = {
                'event': 'ga.event',
                'eCategory': 'Pop-up',
                'eAction': 'Přihlášení',
                'eLabel': type
            };

            form.ajaxSubmitForm($form, $formMsg, 'json', gtmData, function(){
                $form.find('button[type=submit]').attr('disabled', true);
            });
        });
    }


    //======================
    //====ARTICLE RATING====
    //======================
    $('.star-rating :radio').on('change',function () {
        $.ajax({
            url: '/article/rate/' + $(this).parent().data('article-id'),
            type: 'post',
            data: {
                rate: this.value
            },
            success: function (data) {
                if (data.msg != 'already rated') {
                    dataLayer.push({
                        'event': 'ga.event',
                        'eCategory': 'Článek',
                        'eAction': 'Klik',
                        'eLabel': 'Hodnocení'
                    });
                }

                var $articleStars = $(".star-rating-wrapper");
                var $rating = $articleStars.find('.star-rating');
                $rating.removeClass();
                $rating.addClass('star-rating stars-' + data.r + '-5' + ' stars-voted');
                $articleStars.find('.rating-count').text(data.c);
            }
        })
    });

    //======================
    //====KOMENTARE====
    //======================
    $('.fb-comments-toggle').click(function () {
        $('#fb-comments').toggle();
        $(this).toggleClass('fb-comments-toggle-open');
        if ($('.comments-show').text() == 'Skrýt komentáře') {
            $('.comments-show').text('Zobrazit komentáře');
        }
        else {
            $('.comments-show').text('Skrýt komentáře');
        }
    });

    $('.comments-go-to').click(function () {
        $('#fb-comments').show();
        $('.fb-comments-toggle').toggleClass('fb-comments-toggle-open');
        if ($('.comments-show').text() == 'Skrýt komentáře') {
            $('.comments-show').text('Zobrazit komentáře');
        }
        else {
            $('.comments-show').text('Skrýt komentáře');
        }
    });

    //======================
    //====COMPETITION====
    //======================
    var competition = {
        init: function () {
            $('.survey.init[data-competition]').each(function () {
                var competition = $(this);
                competition.find('#firstAnswer').click(function () {
                    competition.hide();
                    $('.survey.correct[data-competition="' + competition.data('competition') + '"]').show();
                });
                competition.find('#secondAnswer').click(function () {
                    competition.hide();
                    $('.survey.bad[data-competition="' + competition.data('competition') + '"]').show();
                });
            });
        }
    };
    competition.init();
    //=======================
    //====ZOB.FOTO.CLANKU====
    //=======================
    $('.gallery-thumb').on('click', function (e) {
        e.preventDefault();

        var $link = $(this);

        dataLayer.push({
            'event': 'ga.event',
            'eCategory': 'Fotogalerie',
            'eAction': 'Zobrazení',
            'eLabel': 'Článek',
            'eventCallback': function () {
                window.location.href = $link.attr('href');
            }
        });
    });

    //=========================
    //====CLANKY KALKULACKA====
    //=========================
    $('.calc-gtm-click-button').click(function (e) {
        e.preventDefault();
        let $link = $(this);
        dataLayer.push({
            'event': 'ga.event',
            'eCategory': 'Článek',
            'eAction': 'Klik',
            'eLabel': 'KalkulačkaBox',
            'eventCallback': function () {
                window.location.href = $link.attr('href');
            }
        });
    });

    //=========================
    //====DOPORUCENY CLANEK====
    //=========================
    $('.rec-article-gtm-click-button').click(function (e) {
        e.preventDefault();
        let $link = $(this);
        dataLayer.push({
            'event': 'ga.event',
            'eCategory': 'Článek',
            'eAction': 'Klik',
            'eLabel': 'DoporučenýČlánek',
            'eventCallback': function () {
                window.location.href = $link.attr('href');
            }
        });
    });

    //======================
    //====CLICK INFOBOX=====
    //======================
    $('.infobox-gtm-click-button').click(function (e) {
        e.preventDefault();
        let $link = $(this);
        dataLayer.push({
            'event': 'ga.event',
            'eCategory': 'Článek',
            'eAction': 'Klik',
            'eLabel': 'InfoBox',
            'eventCallback': function () {
                window.location.href = $link.attr('href');
            }
        });
    });

});



// WEBPACK FOOTER //
// ./app/Resources/assets/js/scripts/articleDetail.js